var MergemodeType = /* @__PURE__ */ ((MergemodeType2) => {
  MergemodeType2[MergemodeType2["Inherit"] = 0] = "Inherit";
  MergemodeType2[MergemodeType2["Replace"] = 1] = "Replace";
  return MergemodeType2;
})(MergemodeType || {});
const workspacePathMatch = "/subscriptions/:subscriptionId/resourceGroups/:resourceGroupName/providers/Microsoft.Experimentation/experimentWorkspaces/:workspaceName";
var ActionNames = /* @__PURE__ */ ((ActionNames2) => {
  ActionNames2["Read"] = "read";
  ActionNames2["Write"] = "write";
  ActionNames2["Admin"] = "admin";
  ActionNames2["MetricWrite"] = "metricWrite";
  return ActionNames2;
})(ActionNames || {});
var IWorkspaceMigrationStatus = /* @__PURE__ */ ((IWorkspaceMigrationStatus2) => {
  IWorkspaceMigrationStatus2["NotStarted"] = "NotStarted";
  IWorkspaceMigrationStatus2["PendingMigration"] = "PendingMigration";
  IWorkspaceMigrationStatus2["Migrating"] = "Migrating";
  IWorkspaceMigrationStatus2["Migrated"] = "Migrated";
  return IWorkspaceMigrationStatus2;
})(IWorkspaceMigrationStatus || {});
export {
  ActionNames,
  IWorkspaceMigrationStatus,
  MergemodeType,
  workspacePathMatch
};
//# sourceMappingURL=MdsDataplaneModels.js.map
